import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeOpenPrice: (value: Nullable<number>) => void;
	isDisabled: boolean;
}

export const OpenPriceInput: React.FC<IProps> = React.memo(({ changeOpenPrice, isDisabled }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(
		() => [{ required: !isDisabled, message: t('enterOpenPrice') }],
		[t, isDisabled],
	);

	return (
		<FormInput
			testId="OpenPriceInput"
			name="openPrice"
			label="openPricePercentLabel"
			min={0}
			precision={2}
			disabled={isDisabled}
			onChangeNumber={changeOpenPrice}
			validationRules={validationRules}
			type="number"
		/>
	);
});
